
import { Injectable } from '@angular/core';
import { DocumentMulti } from './document-multi';

@Injectable({
  providedIn: 'root'
})
export class FullscreenToggleService {


  public constructor() { }


    public toggleFullScreen(): void {
    // ensure ALLOW_KEYBOARD_INPUT is available and enabled
    //@ts-ignore
    const isKeyboardAvailableOnFullScreen = (typeof Element !== "undefined" && "ALLOW_KEYBOARD_INPUT" in Element) && Element.ALLOW_KEYBOARD_INPUT;
    const element = document.documentElement as DocumentMulti;
    const toOpen = !(document.fullscreenElement || element.webkitFullscreenElement || element.mozFullScreenElement);
    if (toOpen) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        const safariVersionReg = /Version\/[\d]{1,2}(\.[\d]{1,2}){1}(\.(\d){1,2}){0,1} Safari/;
        if (safariVersionReg.test(navigator.userAgent)) {
          setTimeout(() => {
            element.webkitRequestFullscreen!();// Safari temporary fix
          })
        } else {
          element.webkitRequestFullscreen(isKeyboardAvailableOnFullScreen as any);
        }
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        //@ts-ignore
      } else if (document.webkitExitFullscreen) {
        //@ts-ignore
        document.webkitExitFullscreen();
      }
    }
  }
}





